(ns machtfit.repository.health-profile
  (:require [machtfit.api :as api]
            [machtfit.repository.core :as repository]
            [machtfit.repository.query :as query]
            [re-frame.core :as rf])
  (:require-macros [reagent.ratom :refer [reaction]]))

(def ^:private db-path-health-profile
  (conj repository/db-path-base :health-profile))

(def ^:private fetch-query-id
  [::fetch])

(rf/reg-event-fx ::store
  (fn [{:keys [db]} [_ health-profile]]
    {:db (assoc-in db db-path-health-profile {:status :done
                                              :health-profile health-profile})}))

(rf/reg-event-db ::reset
  (fn [db _]
    (assoc-in db db-path-health-profile nil)))

(rf/reg-event-fx ::fetch
  (fn [{:keys [db]} _]
    (cond

      (query/running? db fetch-query-id) {}

      :else {:dispatch [::query/register fetch-query-id]
             :post (api/request db
                                {:data `[(:health-profile {} :health-profile)]
                                 :on-error #(rf/dispatch [::query/unregister fetch-query-id])
                                 :on-success #(do
                                                (rf/dispatch [::query/unregister fetch-query-id])
                                                (rf/dispatch [::store (-> % :result :health-profile :result)]))})})))

(rf/reg-sub-raw ::data
  (fn [_ _]
    (reaction
     (repository/async-query-data db-path-health-profile #(rf/dispatch [::fetch])))))
